import { render, staticRenderFns } from "./GoodsStatistics.vue?vue&type=template&id=1dfa6caa&scoped=true&"
import script from "./GoodsStatistics.vue?vue&type=script&lang=js&"
export * from "./GoodsStatistics.vue?vue&type=script&lang=js&"
import style0 from "./GoodsStatistics.vue?vue&type=style&index=0&id=1dfa6caa&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./GoodsStatistics.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfa6caa",
  null
  
)

export default component.exports